// | Functions and types used to describe the `HalogenF` algebra used in a
// | component's `eval` function.
import * as $runtime from "../runtime.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Web$dHTML$dHTMLElement from "../Web.HTML.HTMLElement/index.js";
const identity = x => x;
const tellAll = () => dictIsSymbol => dictOrd => {
  const queryAll2 = Halogen$dQuery$dHalogenM.queryAll()(dictIsSymbol)(dictOrd);
  return label => req => {
    const $0 = queryAll2(label)(req());
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $0._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  };
};
const tell = () => dictIsSymbol => dictOrd => {
  const query2 = Halogen$dQuery$dHalogenM.query()(dictIsSymbol)(dictOrd);
  return slot => label => req => {
    const $0 = query2(slot)(label)(req());
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $0._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  };
};
const requestAll = () => dictIsSymbol => dictOrd => {
  const queryAll2 = Halogen$dQuery$dHalogenM.queryAll()(dictIsSymbol)(dictOrd);
  return label => req => queryAll2(label)(req(identity));
};
const request = () => dictIsSymbol => dictOrd => {
  const query2 = Halogen$dQuery$dHalogenM.query()(dictIsSymbol)(dictOrd);
  return slot => label => req => query2(slot)(label)(req(identity));
};
const mkTell = act => act();
const mkRequest = req => req(identity);
const getHTMLElementRef = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dFree.freeFunctor.map(v => {
    if (v.tag === "Just") { return Web$dHTML$dHTMLElement._read(Data$dMaybe.Nothing, Data$dMaybe.Just, v._1); }
    if (v.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  });
  return x => $0(Control$dMonad$dFree.$Free(
    Control$dMonad$dFree.$FreeView(
      "Bind",
      Halogen$dQuery$dHalogenM.$HalogenF("GetRef", x, Halogen$dQuery$dHalogenM.identity),
      x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
    ),
    Data$dCatList.CatNil
  ));
})();
export {getHTMLElementRef, identity, mkRequest, mkTell, request, requestAll, tell, tellAll};
